import { AddTaskFollowUp } from 'src/actions/task/taskActions';

export const ClientEndpoints = {
  filter: 'api/Client/Filter',
  insert: 'api/Client/Insert',
  GetById: 'api/Client/{id}',
  saleFilter: 'api/Sale/Filter',
  getClientDetails: 'api/Client/GetDetailedClient',
  getSaleDetails: 'api/Sale',
  createVendorContract: 'api/Sale/Insert',
  getVendorFiles: 'api/LeadsFolder/Filter',
  getDetailedClient: 'api/Client/GetDetailedClient',
  GetClientFiles: 'api/ClientFolder/Filter',
  UploadClientFiles: 'api/ClientFiles/Upload',
  InsertClientFiles: 'api/ClientFiles/Insert',

  deleteClientFile: '/api/ClientFiles/Delete',
  deleteLeadFile: '/api/LeadsFolder/Delete',
  editLeadFolder: '/api/LeadsFolder/Update',

  clientFileAdd: 'api/ClientFiles/Upload',
  getClientFolderMembersByFolderId: '/api/ClientFolderUser/GetFolderMembers',

  InsertSaleFiles: 'api/LeadsFiles/Insert',

  InsertClientFolder: 'api/ClientFolder/Insert',
  InsertLeadFolder: 'api/LeadsFolder/Insert',

  getFollowups: 'api/ReFollowUp/Filter',
  getFollowUpsGategorys: 'api/FollowUp/Filter',
  ChangeClientFollowUpStatus: 'api/FollowUp/ChangeStatus',
  AddClientFollowUpEvent: 'api/ReFollowUp/Insert',
  AddReFollowupEvent: 'api/FollowUp/CreateFollowUpWithRefollowUp',
  AddClientFollowUpCategory: 'api/FollowUp/Insert',
  getSaleStatus: 'api/SaleStatus/GetAll',
  deleteContractLead: 'api/Sale/Delete',
  updateLead: 'api/Sale/Update',

  addContact: 'api/ClientMember/Insert',

  dashboard: '/api/Client/GetAllClientDashboard',
  getClientFolderById: 'api/ClientFolder/GetByFolderId',
  getLeadFolderById: 'api/LeadsFolder/GetByFolderId',


  getClientById: 'api/Client',
  updateClient: 'api/Client/Update',
};
